import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { TableHead } from '../ui/table';

// En-tête de colonne triable (clic : croissant → décroissant → sans tri)
export const TriHead = ({ col, tri, onTri, children, className = '' }) => {
  const actif = tri.col === col;
  const Icone = !actif ? ArrowUpDown : tri.dir === 'asc' ? ArrowUp : ArrowDown;
  return (
    <TableHead className={className}>
      <button type="button" onClick={() => onTri(col)} className={`inline-flex items-center gap-1 hover:text-slate-900 ${actif ? 'text-indigo-700 font-semibold' : ''}`} data-testid={`factu-tri-${col}`} title="Trier">
        {children}<Icone className={`w-3 h-3 ${actif ? 'opacity-100' : 'opacity-40'}`} />
      </button>
    </TableHead>
  );
};

export const cycleTri = (tri, col) => tri.col === col ? (tri.dir === 'asc' ? { col, dir: 'desc' } : { col: null, dir: 'asc' }) : { col, dir: 'asc' };

// Valeur de tri d'un document pour une colonne donnée
export const valeurTri = (doc, col, libelleDossier) => ({
  numero: doc.numero || '',
  type: doc.type_document || '',
  dossier: libelleDossier(doc),
  destinataire: doc.destinataire_nom || '',
  bdc: (doc.references_bdc || []).join(' '),
  montant_ht: Number(doc.montant_ht) || 0,
  montant_ttc: Number(doc.montant_ttc || doc.montant_ht) || 0,
  date: doc.date_emission || doc.created_at || '',
  statut: doc.statut || '',
})[col];

export const trierDocuments = (docs, tri, libelleDossier) => {
  if (!tri.col) return docs;
  return [...docs].sort((a, b) => {
    const x = valeurTri(a, tri.col, libelleDossier), y = valeurTri(b, tri.col, libelleDossier);
    const c = typeof x === 'number' ? x - y : String(x).localeCompare(String(y), 'fr', { sensitivity: 'base', numeric: true });
    return tri.dir === 'asc' ? c : -c;
  });
};

export const STATUTS_DOC = [['all', 'Tous statuts'], ['brouillon', 'Brouillon'], ['envoye', 'Envoyé'], ['signe', 'Signé'], ['paye', 'Payé'], ['annule', 'Annulé']];
